var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.10938 7.65625C1.59262 7.65625 1.98438 8.048 1.98438 8.53125V11.5938C1.98438 11.7678 2.05352 11.9347 2.17659 12.0578C2.29966 12.1809 2.46658 12.25 2.64062 12.25H13.3594C13.5334 12.25 13.7003 12.1809 13.8234 12.0578C13.9465 11.9347 14.0156 11.7678 14.0156 11.5938V8.53125C14.0156 8.048 14.4074 7.65625 14.8906 7.65625C15.3739 7.65625 15.7656 8.048 15.7656 8.53125V11.5938C15.7656 12.2319 15.5121 12.844 15.0608 13.2952C14.6096 13.7465 13.9976 14 13.3594 14H2.64062C2.00245 14 1.39041 13.7465 0.939149 13.2952C0.48789 12.844 0.234375 12.2319 0.234375 11.5938V8.53125C0.234375 8.048 0.626126 7.65625 1.10938 7.65625Z",
    fill: "#121622"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4468 5.32184C12.1051 5.66355 11.5511 5.66355 11.2094 5.32184L8 2.11244L4.79059 5.32184C4.44888 5.66355 3.89487 5.66355 3.55316 5.32184C3.21145 4.98013 3.21145 4.42611 3.55316 4.08441L7.38128 0.256281C7.72299 -0.0854277 8.27701 -0.0854277 8.61872 0.256281L12.4468 4.08441C12.7886 4.42612 12.7886 4.98013 12.4468 5.32184Z",
    fill: "#121622"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.0625C7.51675 10.0625 7.125 9.67075 7.125 9.1875L7.125 0.875C7.125 0.39175 7.51675 -1.18742e-07 8 -7.64949e-08C8.48325 -3.42479e-08 8.875 0.39175 8.875 0.875L8.875 9.1875C8.875 9.67075 8.48325 10.0625 8 10.0625Z",
    fill: "#121622"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExport);
export default __webpack_public_path__ + "static/media/icon_export.8b7415ae62495587e5f1814258cec9c2.svg";
export { ForwardRef as ReactComponent };